import React from 'react';

interface CaseLimitModalProps {
  periodEnd: number; // Unix seconds from Stripe
  onUpgrade: () => void;
  onClose: () => void;
}

export default function CaseLimitModal({ periodEnd, onUpgrade, onClose }: CaseLimitModalProps) {
  const isFree = periodEnd === 0;
  const resetDate = isFree ? null : new Date(periodEnd * 1000).toLocaleDateString('pt-BR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  return (
    <div className="action-modal-overlay" onClick={onClose}>
      <div
        className="action-modal case-limit-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="case-limit-title"
        onClick={e => e.stopPropagation()}
      >
        <button className="case-limit-close" onClick={onClose} aria-label="Fechar">✕</button>

        <div className="case-limit-icon-wrap" aria-hidden="true">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        </div>

        <div className="case-limit-header">
          <h3 id="case-limit-title">Limite de Casos Atingido</h3>
          {isFree
            ? <p>Você utilizou seu caso gratuito. Assine um plano para continuar praticando.</p>
            : <p>Você utilizou todos os casos disponíveis no seu plano mensal. Os casos são reiniciados automaticamente todo mês.</p>
          }
        </div>

        <div className="case-limit-info-box">
          <p className="case-limit-info-title">Quer continuar praticando agora?</p>
          <p className="case-limit-info-sub">Faça upgrade e tenha acesso a mais casos clínicos.</p>
        </div>

        {!isFree && (
          <div className="case-limit-reset-date">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
              <line x1="16" y1="2" x2="16" y2="6" />
              <line x1="8" y1="2" x2="8" y2="6" />
              <line x1="3" y1="10" x2="21" y2="10" />
            </svg>
            Reset em: <strong>{resetDate}</strong>
          </div>
        )}

        <div className="case-limit-actions">
          <button className="modal-submit-btn case-limit-upgrade-btn" onClick={onUpgrade}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }} aria-hidden="true">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
            </svg>
            Assinar um Plano
          </button>
          {!isFree && (
            <button type="button" className="case-limit-wait-text" onClick={onClose}>
              Aguardar reset mensal
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
